export class VolumeConversionUtils {
	public static partialVolume(y: number, radius: number, slopeOffset: number) {
		let v = 0;
		for (let n = 0; n <= 200; n++) {
			const x = n / 200;
			const q = (y * x) / slopeOffset;
			const yy = this.ntrp(q, 0, 1, -radius, radius);
			v += this.partCircle(yy, radius);
		}
		return (v * y) / (200 + 1);
	}

	public static fonterraVolumeFromDistance(
		distance: number,
		offset: number,
		slopeOffset: number,
		diameter: number,
		radius: number,
		height: number,
		ventDistance: number,
	): string {
		distance = distance / 1000;
		const angle = Math.atan(slopeOffset / diameter);
		const Hm = height + offset - distance;
		const Hm1 = Hm + ventDistance * Math.tan(angle);
		let Hm2 = Hm1 - slopeOffset;
		if (Hm2 < 0) {
			Hm2 = 0;
		}
		return (((Math.PI * Math.pow(radius, 2) * (Hm1 + Hm2)) / 2) * 1000).toFixed(1);
	}

	public static crownVolumeFromDistance(distance: number, offset: number): string {
		const slope = -6.545294672;
		const yIntercept = 21814.69021;
		const volume = (distance - offset) * slope + yIntercept;
		return volume.toFixed(1);
	}

	public static butterflyVolumeFromDistance(
		distance: number,
		offset: number,
		height: number,
		slopeOffset: number,
		radius: number,
	): string {
		distance = distance / 1000;
		const fluidHeight = height + offset - distance;
		let volume = 0;
		if (fluidHeight < 0) {
			volume = 0;
		} else if (fluidHeight < slopeOffset) {
			volume = VolumeConversionUtils.partialVolume(fluidHeight, radius, slopeOffset);
		} else {
			const fluidHeightLessSlopeOffset = fluidHeight - slopeOffset;
			const slopeVol = (Math.PI * Math.pow(radius, 2) * slopeOffset) / 2;
			const mainVol = Math.PI * Math.pow(radius, 2) * fluidHeightLessSlopeOffset;
			volume = (mainVol + slopeVol) * 1000;
		}
		return volume.toFixed(1);
	}

	public static longveldVolumeFromDistance(
		distance: number,
		offset: number,
		height: number,
		slopeOffset: number,
		radius: number,
	): string {
		distance = distance / 1000;
		const fluidHeight = height + offset - distance;
		let volume = 0;
		if (fluidHeight < 0) {
			volume = 0;
		} else if (fluidHeight < slopeOffset) {
			volume = VolumeConversionUtils.partialVolume(fluidHeight, radius, slopeOffset) * 1000;
		} else {
			const fluidHeightLessSlopeOffset = fluidHeight - slopeOffset;
			const slopeVolume = (Math.PI * Math.pow(radius, 2) * slopeOffset) / 2;
			const mainVolume = Math.PI * Math.pow(radius, 2) * fluidHeightLessSlopeOffset;
			volume = (mainVolume + slopeVolume) * 1000;
		}
		return volume.toFixed(1);
	}

	public static sphericalVolumeFromDistance(
		distance: number,
		offset: number,
		diameter: number,
	): string {
		distance = distance / 1000;
		const fluidHeight = diameter + offset - distance;
		const volume = (Math.PI / 3) * Math.pow(fluidHeight, 2) * (1.5 * diameter - fluidHeight) * 1000;
		return volume.toFixed(1);
	}

	private static ntrp(x: number, xa: number, xb: number, ya: number, yb: number) {
		return ((x - xa) * (yb - ya)) / (xb - xa) + ya;
	}

	private static partCircle(y: number, radius: number) {
		return Math.pow(radius, 2) * Math.acos(-y / radius) + y * Math.sqrt(radius * radius - y * y);
	}
}
